export default "__VITE_ASSET__CkJ$k91c__"